import { parseSelectionSet } from '@graphql-tools/utils';
import { Kind } from 'graphql';
export const forwardArgsToSelectionSet = (selectionSet, mapping) => {
    const selectionSetDef = parseSelectionSet(selectionSet, { noLocation: true });
    return (field) => {
        const selections = selectionSetDef.selections.map((selectionNode) => {
            if (selectionNode.kind === Kind.FIELD) {
                if (!mapping) {
                    return { ...selectionNode, arguments: field.arguments.slice() };
                }
                else if (selectionNode.name.value in mapping) {
                    const selectionArgs = mapping[selectionNode.name.value];
                    return {
                        ...selectionNode,
                        arguments: field.arguments.filter((arg) => selectionArgs.includes(arg.name.value)),
                    };
                }
            }
            return selectionNode;
        });
        return { ...selectionSetDef, selections };
    };
};
//# sourceMappingURL=selectionSetArgs.js.map